import { skillShortSchema } from '../../../../shared/source/data-contract/skill';

import type { LanguageCode } from '../../../../shared/source/internationalization';
import type { ValidatingHttpFetcherWithBaseUrl } from '../../../../shared/source/validating-http-fetcher';

export type LoadSkillsBySearchTermOptions = {
    readonly acceptLanguage: LanguageCode;
    readonly searchTerm: string;
};

export const createLoadSkillsBySearchTermRequest = (
    validatingCobrainerApiFetcher: ValidatingHttpFetcherWithBaseUrl,
) => {
    return (options: LoadSkillsBySearchTermOptions, abortSignal?: AbortSignal) => {
        const { acceptLanguage, searchTerm } = options;

        return validatingCobrainerApiFetcher.get(skillShortSchema.array(), {
            pathname: `/skills`,
            requestOptions: {
                headers: {
                    'Accept-Language': acceptLanguage,
                },
                searchParams: {
                    limit: 10,
                    searchTerm,
                    type: ['hard', 'soft', 'language'].join(','),
                },
                signal: abortSignal,
            },
        });
    };
};
